<div class="viewAttachmentModal">
    
    <div class="modal-header com-modal-header">
        <div class="row com-modal-row" >
        <div class="mr-auto h4 com-modal-m">
            <h4 class="com-modal-tittle">INVOICE NUMBER : {{invDetails?.Id}}</h4>
        </div>
        <div class="com-modal-tittle-div"> 
            <i class="mdi mdi-close com-modal-icon" (click)="dismiss()"></i>
        </div>
        </div>
        <div class="row com-modal-row" style="margin-top: -25px;" >
            <div class="mr-auto h4 com-modal-m">
                <h4 class="com-modal-tittle">{{invDetails?.ResolutionDescription}}</h4>
            </div>
            <div class="com-modal-tittle-div" style="margin-top: 10px;"> 
                <span class="inWeb_status" style="margin-right: 10px;">Web Resolution</span>
                <span class="com-modal-tittle" style="font-weight: 600;">{{invDetails?.ResolutionReasonCode}}</span>
            </div>
        </div>
        <div class="comments">​{{invDetails?.Comments}}
        </div>
    </div>

    <div class="modal-body com-modal-body" style="margin-top: 15px;">
        <div style="display: flex;margin-bottom: 15px;">
            <div style="width: 100%;margin-left: 10px;">
                <h6 class="grid-ctgf-top-right">​Rate File Name: </h6>
                <div class="grid-ctgf-top-right-fjl viewAttachmentModal-title" >{{invDetails?.RateFileName}}
                </div>
            </div>
            <div style="width: 100%;">
                <h6 class="grid-ctgf-top-right" >Current Status (days)</h6>
                <h5 class="grid-ctgf-top-right-fjl viewAttachmentModal-title">{{invDetails?.DaysInResolution}}</h5>
            </div>
            <div style="width: 100%;">
                <h6 class="grid-ctgf-top-right" >​Days to Due Date</h6>
                <h5 class="grid-ctgf-top-right-fjl viewAttachmentModal-title">{{invDetails?.DaysToDueDate}}</h5>
            </div>

            <div style="width: 100%;">
                <h6 class="grid-ctgf-top-right" >Times in Web Resolution</h6>
                <h5 class="grid-ctgf-top-right-fjl viewAttachmentModal-title">{{invDetails?.NumberOfTimesInResolution}}</h5>
            </div>
            <div style="width: 10%;">
                <h6 class="grid-ctgf-top-right">Shipments</h6>
                <h5 class="grid-ctgf-top-right-fjl viewAttachmentModal-title">{{invDetails?.NoOfShipment}}</h5>
            </div>
        </div>
        <div class="row">
            <div class="col-md-9">
                
                    <table class="table wl-table-m viewAttachmentModal-table" >
                        <thead class="wl-thead-b">
                            <tr>
                                <th><h6>INVOICE DATE</h6></th>
                                <th><h6>DUE DATE</h6></th>
                                <th><h6>CLIENT</h6></th>
                                <th><h6>CARRIER</h6></th>
                                <th><h6>MODE</h6></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{invDetails?.ClientCode}}</td>
                                <td>{{invDetails?.CarrierName}}</td>
                                <td>{{invDetails?.ShipmentMode}}</td>
                            </tr> 
                        </tbody>
                </table>
               
            </div>
            <div class="col-md-3">
               
                <table class="table wl-table-m viewAttachmentModal-table" >
                        <thead class="wl-thead-b">
                            <tr>
                                <th><h6>CURRENCY</h6></th>
                                <th><h6>INVOICE AMOUNT</h6></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td >{{invDetails?.Currency}}</td>
                            </tr> 
                        </tbody>
                </table>
            
            </div>
        </div>
        <div class="row" >
            <div class="col-md-9">
            
                <table class="table wl-table-m viewAttachmentModal-table">
                        <thead class="wl-thead-b" >
                        <tr>
                            <th><h6>SERVICE</h6></th>
                            <th><h6>ORIGIN</h6></th>
                            <th><h6>DESTINATION</h6></th>
                            <th><h6>REASON CODE</h6></th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td >{{invDetails?.ServiceLevel}}</td>
                                <td >{{invDetails?.OriginCountryCode}}</td>
                                <td >{{invDetails?.DestinationCountryCode}}</td>
                                <td >{{invDetails?.ResolutionReasonCode}}</td>
                            </tr> 
                        </tbody>
                </table>
          
            </div>
            <div class="col-md-3">
                <div class="viewAttachmentModal-controls">

                    <div>
                        <span class="va-title">{{invDetails?.DocumentType}}</span>
                    </div>
                
                    <div>
                        <a (click)="openInvoice(invDetails?.InvoiceFile,invDetails?.Id)" style="margin: 5px;"><img src="../../assets/icons/pdf-icon-25x25.svg"alt=""></a>
                        <a (click)="openDownload(invDetails?.Id)"><img src="../../assets/icons/xls-icon-25x25.svg" alt=""></a>
                        <button class="freight-primary grid-btn" (click)="viewClickDisplay1(invDetails?.Id)">View</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>